import AppMediumState from "@/models/Settings/AppMediums/AppMediumState";

export default (appMediumState: AppMediumState) => {
    let returnVal = "Undefined";
    switch (appMediumState) {
        case AppMediumState.Enabled:
            returnVal = "Enabled"
            break;
        case AppMediumState.Disabled:
            returnVal = "Disabled"
            break;
    }
    return returnVal;
}